import React, { Fragment, useContext, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { BasicContext } from "../../App";
import LoginForm from "../../components/forms/LoginForm";
import OnlyLogoNavbar from "../../components/navbars/OnlyLogoNavbar";
import { postMethod } from "../../requests";
import $ from "jquery";

const LoginPage = () => {
    const { t } = useTranslation();
    const [blockForm, setBlockForm] = useState(false);
    const { checkServerData, setIsLogged, setShowView, setAlerts } = useContext(BasicContext);

    const handleLogin = async (data) => {
        const res = await postMethod("/login", {
            email: data.username,
            password: data.password,
            moduleName: "ADMIN_APP",
        });
        if (checkServerData(res)) {
            setAlerts([{ variant: "success", message: t("success.login"), fading: 1000, id: "login" }]);
            setIsLogged(res.data);
            setShowView({ nav: "users", sub: "usersList" });
        }
        setBlockForm(false);
    };

    const handleSetContainerHeight = () => {
        $("#adminLoginContainer").height(`${window.innerHeight - $("#footerMain").outerHeight() - 61}px`);
    };

    useEffect(() => {
        handleSetContainerHeight();
        window.removeEventListener("resize", handleSetContainerHeight);
        document.querySelectorAll("input").forEach((input) => {
            input.addEventListener("focus", (event) => {
                if (event.target.matches(":-webkit-autofill")) {
                    const value = input.value; // Tymczasowe zapisanie wartości
                    input.value = ""; // Wyczyszczenie pola
                    input.value = value; // Przywrócenie wartości (odświeżenie)
                }
            });
        });
        // eslint-disable-next-line
    }, []);

    return (
        <Fragment>
            <OnlyLogoNavbar id="adminLoginNavbar" />
            <Container id="adminLoginContainer">
                <Row>
                    <Col xs={12} lg={{ span: 6, offset: 3 }}>
                        <Row>
                            <Col xs={12} className="pt-lg-5 pt-0">
                                <h1 className="h4 p-4">{t("logIn")}</h1>
                            </Col>
                            <Col xs={12}>
                                <Row>
                                    <LoginForm blockForm={blockForm} onBlockForm={setBlockForm} onLogin={handleLogin} />
                                </Row>
                                <Row>
                                    <Col className="text-center">
                                        <a
                                            href={`${process.env.REACT_APP_URL}/app`}
                                            target="_blank"
                                            rel="noreferrer"
                                            className="btn btn-outline-primary"
                                            aria-label={t("schedule.signUpForClassAriaLabel")}
                                        >
                                            {t("goToAppPanel")}
                                        </a>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                </Row>
            </Container>
        </Fragment>
    );
};

export default LoginPage;
